import { lazy } from "react";
import { DOMAIN_TYPES } from "./config/domainTypes";

export const DOMAIN_APP_REGISTRY = Object.freeze({
  [DOMAIN_TYPES.EDUCATION]: lazy(() => import("./education/EducationApp.jsx")),
  [DOMAIN_TYPES.RETAIL]: lazy(() => import("./catalog/RetailApp.jsx")),
  [DOMAIN_TYPES.FLEX_OFFICE]: lazy(() => import("./flexOffice/FlexOfficeApp.jsx")),
  [DOMAIN_TYPES.INSTITUTION]: lazy(() => import("./institution/InstitutionApp.jsx")),
  [DOMAIN_TYPES.ASSESSMENT]: lazy(() => import("./assessment/AssessmentApp.jsx")),
  [DOMAIN_TYPES.SERVICES]: lazy(() => import("./services/ServicesApp.jsx")),
  [DOMAIN_TYPES.WAAS]: lazy(() => import("./waas/WaasApp.jsx")),
  [DOMAIN_TYPES.KRUMAGO]: lazy(() => import("./krumago/KrumagoApp.jsx")),
});

export const getDomainApp = (domainType) => DOMAIN_APP_REGISTRY[domainType] || null;

